import { Seal, UnsavedSeal } from '@paragon/contract-library';

import { SealingService } from '../connections';

export function fetch(userEmail: string): Promise<readonly Seal[]> {
  return SealingService.get('seals', { params: new URLSearchParams({ userEmail }) });
}

export function remove(sealId: number) {
  return SealingService.delete<Seal>(`seals/${sealId}`);
}

export function update(seal: Seal) {
  return SealingService.put<Seal>(`seals/${seal.id}`, { data: seal });
}

export function create(seal: UnsavedSeal) {
  return SealingService.post<Seal>('seals', { data: seal });
}
